var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4459 12.7106C15.8373 12.4509 15.1322 12.6216 14.7129 13.1337L13.4809 14.6403C11.7738 13.6495 10.3488 12.2245 9.35802 10.5175L10.861 9.28913C11.3731 8.8698 11.5475 8.16472 11.284 7.55613L9.50275 3.39988C9.22443 2.74675 8.52306 2.38308 7.82911 2.53152L3.67286 3.42214C2.99005 3.56687 2.50021 4.17175 2.50021 4.87312C2.50021 13.4528 9.00177 20.5184 17.3477 21.4053C17.7113 21.4425 18.075 21.4721 18.4461 21.487H18.4498C18.6762 21.4944 18.8988 21.5018 19.1252 21.5018C19.8266 21.5018 20.4315 21.012 20.5762 20.3292L21.4668 16.1729C21.6152 15.479 21.2516 14.7776 20.5985 14.4993L16.4422 12.718L16.4459 12.7106ZM18.884 19.7169C10.8795 19.587 4.41134 13.1188 4.28517 5.11433L7.96642 4.3239L9.56212 8.04968L8.2299 9.1407C7.5545 9.69363 7.38009 10.6548 7.81798 11.4118C8.96466 13.3897 10.6123 15.0374 12.5902 16.1841C13.3473 16.6219 14.3084 16.4475 14.8613 15.7721L15.9524 14.4399L19.6781 16.0356L18.884 19.7169Z",
    fill: "#83D9FF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.c4406dd41033b1d5a35667792d7eb682.svg";
export { ForwardRef as ReactComponent };